<script setup lang="ts">
import { mdiContentSaveAllOutline, mdiUndo } from "@mdi/js";
import { Button, Icon } from "@soft-db/ui";
import StickyWatcher from "./StickyWatcher.vue";

defineProps({
	hasChanges: {
		type: Boolean,
		required: true,
	},
	saveDisabled: {
		type: Boolean,
	},
	loading: {
		type: Boolean,
	},
});
defineEmits(["save", "undo"]);
defineSlots<{ prepend(props: { sticking: boolean }): void }>();

const { t } = useI18n();
</script>

<template>
	<StickyWatcher v-slot="{ sticking }" position="after">
		<div
			:class="{
				'flex h-fit min-h-16 w-full items-center py-2 transition-all': true,
				'z-1 sticky bottom-0': hasChanges,
				'bg-base-300 border-border rounded-none border-t-2 px-0': !hasChanges || !sticking,
				'bg-base-100 border-border rounded-t-md border border-b-0 px-4 shadow-md':
					sticking && hasChanges,
			}"
		>
			<slot name="prepend" :sticking="sticking" />

			<!-- TODO: add sm breakpoint where button has no text instead of wraping (remove py-2 above) -->
			<div class="ml-auto flex flex-wrap items-center justify-end gap-4">
				<Button v-if="hasChanges" variant="ghost" size="sm" @click="$emit('undo')">
					<Icon :d="mdiUndo" />
					<span>{{ t("common.undoChanges") }}</span>
				</Button>
				<Button
					class="min-w-36"
					color="primary"
					size="md"
					:loading="loading"
					:disabled="!hasChanges || saveDisabled || loading"
					@click="$emit('save')"
				>
					<Icon :d="mdiContentSaveAllOutline" />
					<span>{{ t("common.save") }}</span>
				</Button>
			</div>
		</div>
	</StickyWatcher>
</template>
